/* DOMAIN API KEY */
export const API_KEYS = {
  yoyo: 'WMXcFqe65MXcK4vpfcF',
  raiplay: 'arSgRtwasD324SaA',
  radio: 'fnrtydo24heiuhihExx',
  rai: 'das554fds34safd2As',
  raiplay2020: 'arSgRtwasD324SaA',
  sound: 'newApiKeyRaiRadio'
};

/* SERVICE BASE URL */
export const BASE_URL = {
  default: '/',
  test: '//sttest.rai.it/'
};

export const GIGYA_API_KEYS = {
  raiPlay: '3_I55u9iiGSTrsMk0Tr9SlgcL37clRoL_wyiCxSRPWD_6tBccbLbPGAyOmekkrpoEn',
  radio: '3_qkVbqpKn13tlaYY1tlYE6wer43ZRo1XmYZBOhvWwIpVQLsdeOTQZF-sK1M85Catz',
  raiSport: '3_dUbVa2fC1BkaWR_Suy7Jhw4S_CmYNUU4ViCnO2tmiAEpIjKGgcoNkAPMSbr5XrJC',
  stTest: '3_i_Ms574WFExW0zCNlQEAVxX7brDQQ7OTgsR8WDOdtNKVxNZRPiNsVQi57ZoPq0qb',
  raiTv: '3_H6AyGSYZJkl6L9-AVpZS3UHc2twYG3rxy_5IHTpEVGIIopQd3lQzbenhWgyRl3Ap',
  rai: '3_xVTjKOtf9coz04AzqDj05XeSgBqH9zVQxmQtWJOC_y_fcdC0idy7H5ECPwjD6VYW',
  gigya_test_rai: '3_j85AJRao6Juhh_I_gponGAA4oGNKjFhtAvBw3slTTfCgfn0lMwZzweBE865vDZEZ'
};

export const LAST_PUBBLICITA_PROFILATA_VERSION = "2020-09-01"